import React from "react";

import { Flex, Heading } from "@chakra-ui/react";

export default function Navbar() {
  return (
    <Flex as="nav" p="10px" alignItems="center" bg="gray.50">
      <Heading as="h1">Phonebook</Heading>
    </Flex>
  );
}
